import type React from 'react';
import { createContext, useContext } from 'react';

interface IScrollContext {
    offsetTop: number;
    scrollRef?: React.RefObject<HTMLElement | HTMLDivElement>;
}

export const ScrollContext = createContext<IScrollContext>({
    offsetTop: 0,
});

ScrollContext.displayName = 'Sticky.ScrollContext';

export const useScrollRef = () => useContext(ScrollContext).scrollRef;
